// app/dipendente/dipendenti.js

(function () {
    'use strict';
    var controllerId = 'dipendente_super';
    angular.module('app').controller(controllerId, ['$rootScope', '$routeParams', '$filter', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', dipendente_superFn]);

    function dipendente_superFn($rootScope, $routeParams, $filter, common, bDialog, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Dipendenti';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);                
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.super = $rootScope.isAuthorized('SUPER');        
                
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['nominativo', 'matricola', 'sezione'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };

        //Elenchi dettaglio
        vm.list.sezioni = [];
        vm.list.profili = [];           //Profili orari del dipendente
        vm.list.profiloOre = [];        //Elenco profili orari generale
        vm.list.nonAttivi = [];

        vm.provincie = [];
        vm.comuni = [];
        vm.getComuni = getComuni;
        //data
        vm.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened = !vm.opened;
        };

        vm.open2 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened2 = !vm.opened2;
        };

        vm.open3 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened3 = !vm.opened3;
        };

        vm.clear = function ($event) {
            vm.fData = '';
            vm.changed = true;
        };
        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        //Filtro
        vm.filter = {};
        vm.filter.stato = vm.fStato = 0;
        vm.filter.sezione = vm.fSezione = 0;
        vm.filter.ricerca = vm.fRicerca = '';
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;              
        vm.getRecord = getRecord;        
        vm.get = getRecord;
        vm.add = addDipendente;
        vm.update = updateItem;
        vm.delete = deleteItem;
        vm.getNonAttivi = getNonAttivi;

        //Gestione costi        
        vm.addCosto = addCosto;
        vm.editCosto = editCosto;
        vm.deleteCosto = deleteCosto;        

        //Gestione profilo orario 
        vm.selezionaProfilo = selezionaProfilo
        vm.profilo = {};
        vm.deleteProfilo = deleteProfilo;

        //Gestione account
        vm.getAccount = getAccount;
        vm.updateAccount = updateAccount;
        vm.resetPassword = resetPassword;
        vm.invioCredenziali = invioCredenziali;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getSezioni(), getProfiloOre()/*, getProfilo()*/];
            common.activateController(promises, controllerId)
                .then(function () {
                    if ($routeParams.DipendenteId != null) {
                        setView('detail');
                        getRecord($routeParams.DipendenteId, 0);
                    }
                });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.stato = vm.fStato == null ? 0 : vm.fStato;
            vm.filter.sezione = vm.fSezione == null ? 0 : vm.fSezione;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.dipendente_countAll(vm.filter.stato, vm.filter.sezione, vm.filter.ricerca).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.dipendente_getAll(vm.pageSize, vm.page, vm.filter.stato, vm.filter.sezione, vm.filter.ricerca, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    vm.records.push.apply(vm.records, data);                   
                }
                vm.loading = false;               
            });            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) { 
            vm.list.profili = []; 
            if (vm.provincie.length == 0) getProvincie();

            return datacontext.dipendente_get(id).then(function (data) {                
                vm.index = index;
                vm.record = data;
                //console.info("vmrecord", vm.record);

                //Azzera liste
                getComuni(vm.record.ProvinciaId);

                if (vm.record.DataAssunzione != null) vm.record.DataAssunzione = new Date(vm.record.DataAssunzione);
                if (vm.record.DataLicenziamento != null) vm.record.DataLicenziamento = new Date(vm.record.DataLicenziamento);
                if (vm.record.DataNascita != null) vm.record.DataNascita = new Date(vm.record.DataNascita);
                                
                if (vm.super)
                    getAccount();
                                
                setView('detail');
            });
        }

        function addRecord(id) {
            return datacontext.dipendente_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function getProvincie() {
            if (vm.provincie.length > 0) return;

            datacontext.arrProvincie().then(function (data) {
                vm.provincie = data;
            });
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return vm.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.comuni = data;
            });
        }
        //Get list
        function getSezioni() {
            return datacontext.sezione_getAllList().then(function (data) {                
                return vm.list.sezioni = data;
            });
        }

        //Get list
        function getProfiloOre() {
            return datacontext.profiloOre_getAllList().then(function (data) {
                return vm.list.profiloOre = data;
            });
        }
               
        //add
        function addDipendente() {
            var modalDipendente = {};
            modalDipendente.Id = 0;   
            
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/dipendenteAdd.html?version=30',  
                controller: 'dipendenteAdd',
                resolve: {
                    dipendente: function() {
                        return modalDipendente;
                    },
                    sezioni: function() {
                        return vm.list.sezioni;
                    },
                    profiliOre: function () {
                        return vm.list.profiloOre;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la modifica del dato ');
                logSuccess('Dipendente aggiunto con successo ');
                addRecord(returnItem.Id);

                //cerca();
            });
        }

        //update
        function updateItem() {
            return datacontext.dipendente_update(vm.record).then(function (data) {
                if (data)
                    logSuccess('Dato salvato');
                else
                    logError('Impossibile salvare il dato');
            });
        }

        //delete
        function deleteItem(item) {           
            var msg = ' il dipendente ' + item.Nominativo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.dipendente_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');
                    logSuccess('Dipendente eliminato con successo ');
                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        //Gestione costi        
        function addCosto() {
            var modalCosto = {};
            modalCosto.Id = 0;
            modalCosto.DipendenteId = vm.record.Id;
            modalCosto.CostoOra = vm.record.CostoOra;
            modalCosto.Anno = (new Date()).getFullYear();

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/costoAddEdit.html?version=30',
                controller: 'costoAddEdit',
                resolve: {
                    costo: function () {
                        return modalCosto;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la modifica del dato ');

                logSuccess('Costi aggiunti con successo ');
                vm.record = getRecord(vm.record.Id, vm.index);
            });
        }

        function editCosto(item) {
            var modalCosto = {};
            angular.copy(item, modalCosto);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/costoAddEdit.html?version=30',
                controller: 'costoAddEdit',
                resolve: {
                    costo: function () {
                        return modalCosto;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la modifica del dato ');                

                logSuccess('Costi modificati con successo ');
                vm.record = getRecord(vm.record.Id, vm.index);
            });
        }

        function deleteCosto(item) {
            var msg = "i costi per la data fine " + item.DataFine;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.costoDipendente_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');
                    vm.record = getRecord(vm.record.Id, vm.index);
                });
            });
        }

        //Gestione Profilo orario

        function selezionaProfilo() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/profiloOrarioSelect.html?version=30',
                controller: 'profiloOrarioSelect',
                windowClass: 'modal-wide',
                resolve: {                 
                    profiliOre: function () {
                        return vm.list.profiloOre;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                returnItem.DipendenteId = vm.record.Id;                
                   
                return datacontext.profiloDipendenti_add(returnItem).then(function (data) {                        
                        if (data && data.Id && data.Id > 0) {
                            vm.record = getRecord(vm.record.Id, vm.index);
                            logSuccess('Dati salvati');                            
                        }
                        else
                            return logError('Impossibile salvare i dati');
                    });
                });            
        }

        function deleteProfilo(item) {
            var msg = "il profilo orario " + item.profiloOreTipo + " dal Dipendente " + vm.record.Nominativo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.profiloDipendenti_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');
                    logSuccess('Profilo eliminato con successo ');
                    vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione
                    //console.info("vmrecord", vm.record);                    
                });
            });
        }



        //Gestione account
        function getAccount() {            
            datacontext.user_getByDipendenteId(vm.record.Id).then(function (data) {                
                vm.account = data;
                vm.account.DtAttivazione = $filter('date')(data.DtAttivazione, 'dd/MM/yyyy');
            });
        }

        function updateAccount() {
            vm.account.DtAttivazione = common.stringToDate(vm.account.DtAttivazione);
            return datacontext.user_update(vm.account).then(function (data) {
                if (!data) {
                    logSuccess('Dato salvato');
                }
                else
                    logError('Impossibile salvare il dato');
            });
        }

        //Manda una email all'utente con un link di accesso al Reset Password
        //dove l'utente può inserire una nuova password per il suo account
        function resetPassword() {
            var msg = 'Sara\' inviata una email all\'utente ' + vm.account.Username + ' contenente le istruzioni per eseguire il reset della password. Continuare?';
            bDialog.confirmationDialog('Reset Password', msg, 'OK').then(function () {
                return datacontext.user_resetPassword(vm.account.Email).then(function (data) {
                    if (data != "204") return logError('Impossibile eseguire l\'operazione');

                    logSuccess('Operazione effettuata con successo ');
                });
            });
        }

        function invioCredenziali() {
            var msg = 'Sara\' inviata una email all\'utente ' + vm.account.Username + ' contenente le credenziali per l\'accesso alla piattaforma. Continuare?';
            bDialog.confirmationDialog('Invio Credenziali', msg, 'OK').then(function () {
                return datacontext.user_invioCredenziali(vm.account.Email).then(function (data) {
                    if (data != "204") return logError('Impossibile eseguire l\'operazione');
                    logSuccess('Operazione effettuata con successo ');
                });
            });
        }

        function getNonAttivi(matricola) {
            datacontext.dipendente_getAllNonAttivi(matricola).then(function (data) {                
                return vm.list.nonAttivi = data;
            });
        }
    }
})();
